<script>
	import { Modals, closeModal, openModal } from 'svelte-modals';
	import { app } from '$lib/stores/app/store';
	import LoadingModalContent from './LoadingModalContent.svelte';

	$: loading = $app?.global?.loading;

	$: if (loading) {
		openModal(LoadingModalContent);
	} else {
		closeModal();
	}
</script>

<Modals>
	<div
		slot="backdrop"
		class="backdrop cursor-default"
		class:z-102={loading}
		role="button"
		aria-pressed="false"
		tabindex="0"
		on:click={() => window.dispatchEvent(new CustomEvent('global:backdrop-click'))}
		on:keydown={() => window.dispatchEvent(new CustomEvent('global:backdrop-click'))}
	/>
</Modals>
